import $ from 'jquery';
import UrlUtils from 'lib/url-utils';

$(() => {
	if($('.card-block .collapse').length > 0) {
		var showParam = UrlUtils.getUrlParameter('show');
		if(showParam !== null && typeof showParam !== 'undefined') {
			var target = showParam;
			var collapse = $("[id^='" + target + "']").first();
			var card = collapse.closest('.card');
			collapse.collapse('show');
			window.lthelp.scrollTo(card, -12, 500);
		}
	}
});
